"use client";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

import { OpportunitiesDataTable } from "../opportunities/table-componentsB/data-table";
import { columns } from "../opportunities/table-componentsB/columns";

const OpportunitiesView = ({
  data,
  crmData,
}: {
  data: any;
  crmData: any;
}) => {
  const router = useRouter();
  const [isMounted, setIsMounted] = useState(false);

  // Filter the opportunities where assigned_account name is "Bevel"
  const filteredOpportunities = data.filter(
    (opportunity: { assigned_account: { name: string; }; }) => opportunity.assigned_account?.name === "Bevel"
  );

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
    <Card className="shadow-lg">
      <CardHeader className="pb-3">
        <div className="flex justify-between">
          <div>
            <CardTitle>Bevel Deals</CardTitle>
            <CardDescription></CardDescription>
          </div>
        </div>
      </CardHeader>

      <CardContent>
        {!data || data.length === 0 ? (
          "No assigned opportunities found"
        ) : (
          <OpportunitiesDataTable columns={columns} data={filteredOpportunities} />
        )}
      </CardContent>
    </Card>
  );
};

export default OpportunitiesView;
